import { Box, Text } from '@fairfashion/design-system'

import { docMask } from '../../utilities/masks/brasilianDocuments'

import { IDeclarationTableProps } from './declaration-table.types'

export const DeclarationTable = ({
  declaration,
  size = 'normal',
}: IDeclarationTableProps) => {
  const formatPercentage = (percentage: number) => {
    return `${percentage.toFixed(2)}%`
  }

  return (
    <Box direction="column" gap={2} width="100%">
      <Box width="100%" gap={size === 'small' ? 2 : 3}>
        <Box width="75px" justifyContent="center">
          <Text
            fontWeight={400}
            size={size === 'small' ? 'small' : 'normal'}
            color="grey_3"
          >
            Declarado
          </Text>
        </Box>

        <Box flex={1}>
          <Text
            fontWeight={400}
            size={size === 'small' ? 'small' : 'normal'}
            color="grey_3"
          >
            Fornecedor
          </Text>
        </Box>
        <Box width="100px" justifyContent="flex-end">
          <Text
            fontWeight={400}
            size={size === 'small' ? 'small' : 'normal'}
            color="grey_3"
          >
            Rastreado
          </Text>
        </Box>
      </Box>

      <Box direction="column" gap={size === 'small' ? 2 : 4} width="100%">
        {declaration.lines
          .sort((a, b) => b.percentageOfDeclaration - a.percentageOfDeclaration)
          .map((line, index) => (
            <Box
              key={`line-${index}`}
              direction="row"
              gap={size === 'small' ? 2 : 3}
              width="100%"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box
                padding={1}
                borderRadius="6px"
                border={{ width: 1, color: 'grey_4' }}
                width="75px"
                justifyContent="center"
              >
                <Text
                  fontWeight={400}
                  size={size === 'small' ? 'small' : 'normal'}
                  color="grey_2"
                >
                  {formatPercentage(line.percentageOfDeclaration)}
                </Text>
              </Box>
              <Box flex={1} direction="column" gap={1}>
                <Text
                  size={size === 'small' ? 'small' : 'normal'}
                  color="grey_1"
                >
                  {line.provider?.name}
                  <Text size="small" color="grey_3">
                    {docMask(line.provider?.taxId ?? '')}
                  </Text>
                </Text>
              </Box>

              <Box width="100px" justifyContent="flex-end">
                <Box
                  padding={1}
                  borderRadius="6px"
                  width="75px"
                  justifyContent="center"
                  backgroundColor={
                    line.percentageTracked >= 80
                      ? 'success'
                      : line.percentageTracked >= 50
                        ? 'warning'
                        : 'error'
                  }
                >
                  <Text
                    fontWeight={500}
                    size={size === 'small' ? 'small' : 'normal'}
                    color="white"
                  >
                    {formatPercentage(line.percentageTracked)}
                  </Text>
                </Box>
              </Box>
            </Box>
          ))}
      </Box>
    </Box>
  )
}
